module.exports = __webpack_public_path__ + "img/wqa.b531311d.png";